import { render, staticRenderFns } from "./PageEmptyRouter.vue?vue&type=template&id=1484fedb&scoped=true&"
import script from "./PageEmptyRouter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageEmptyRouter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PageEmptyRouter.vue?vue&type=style&index=0&id=1484fedb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484fedb",
  null
  
)

export default component.exports